<template>
    <div>
        <TopAds/>
        <HeaderPage/>
        <div class="container">
            <div class="index_top">
                <div style="height: 25px;"></div>
                <div v-for="(item,index) in guoneitop" :key="index">
                    <h2 style="padding-top:0px;" v-if="index==0">
                        <a :href="item.link" v-if="item.type==4" target="_blank" title="item.title" style="color:#3848a0">
                            {{item.title}}
                        </a>
                        <router-link :to="'/special/node_'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==3" style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/video/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==2" style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/album/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==1" style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/article/show-'+item.basic_id+'.html'" title="item.title" v-else  style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                    </h2>
                </div>
                <div>
                    <div class="top_more" style="display:none">
                        <router-link to="/list_100.html">更多</router-link>
                    </div>
                    <span v-for="(item,index) in guoneitop" :key="index">
                        <span v-if="index>0">
                            <a :href="item.link" v-if="item.type==4" target="_blank" title="item.title">
                            {{item.title}}
                            </a>
                            <router-link :to="'/special/node_'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==3" target="_blank">
                                {{item.title}}
                            </router-link>
                            <router-link :to="'/video/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==2" target="_blank">
                                {{item.title}}
                            </router-link>
                            <router-link :to="'/album/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==1" target="_blank">
                                {{item.title}}
                            </router-link>
                            <router-link :to="'/article/show-'+item.basic_id+'.html'" title="item.title" v-else target="_blank">
                                {{item.title}}
                            </router-link>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <div class="container">
            <!-- PC端专题-->
            <div class="specal_foucs">
                <div class="specal_type">
                    本<br>网<br>推<br>荐
                </div>
                <div class="specal_scroll">
                    <swiper
                        :modules="modules"
                        :slides-per-view="specialrows"
                        :space-between="20"
                        navigation
                        autoplay
                        @swiper="onSwiper"
                        @slideChange="onSlideChange"
                    >
                        <swiper-slide v-for="(item,index) in specials" :key="index" class="specal_item">
                            <div class="specal_img">
                                <a :href="item.link?item.link:'#'" target="_blank">
                                    <img :src="'https://www.ynqjnews.net'+item.image" :title="item.name">
                                </a>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="index_bd_top">
                <div style="height: 25px;"></div>
                <div v-for="(item,index) in bdnewstop" :key="index">
                    <h2 style="padding-top:0px;" v-if="index==0">
                        <a :href="item.link" v-if="item.type==4" target="_blank" title="item.title" style="color:#3848a0">
                            {{item.title}}
                        </a>
                        <router-link :to="'/special/node_'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==3" style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/video/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==2" style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/album/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==1" style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/article/show-'+item.basic_id+'.html'" title="item.title" v-else style="color:#3848a0" target="_blank">
                            {{item.title}}
                        </router-link>
                    </h2>
                </div>
                <div>
                    <div class="top_more" style="display:none">
                        <router-link to="/list_100.html">更多</router-link>
                    </div>
                    <span v-for="(item,index) in bdnewstop" :key="index">
                        <span v-if="index>0">
                            <a :href="item.link" v-if="item.type==4" target="_blank" title="item.title">
                            {{item.title}}
                            </a>
                            <router-link :to="'/special/node_'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==3" target="_blank">
                                {{item.title}}
                            </router-link>
                            <router-link :to="'/video/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==2" target="_blank">
                                {{item.title}}
                            </router-link>
                            <router-link :to="'/album/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==1" target="_blank">
                                {{item.title}}
                            </router-link>
                            <router-link :to="'/article/show-'+item.basic_id+'.html'" title="item.title" v-else target="_blank">
                                {{item.title}}
                            </router-link>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-7 index_bigfoucs">
                    <div id="newsfoucs" class="carousel slide foucs_news" data-bs-ride="carousel">
                        <!-- 指示符 -->
                        <div class="carousel-indicators">
                            <button v-for="(item,index) in foucsnews" :key="index" type="button" data-bs-target="#newsfoucs" :data-bs-slide-to="index" :class="index==0?'active':''"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item" v-for="(item,index) in foucsnews" :key="index" :class="index==0?'active':''">
                                <a :href="item.link" v-if="item.type==4" target="_blank" title="item.title">
                                    <img class="foucs_img" :src="item.cover" :title="item.name">
                                </a>
                                <router-link :to="'/special/node_'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==3" target="_blank">
                                    <img class="foucs_img" :src="item.cover" :title="item.name">
                                </router-link>
                                <router-link :to="'/video/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==2" target="_blank">
                                    <img class="foucs_img" :src="item.cover" :title="item.name">
                                </router-link>
                                <router-link :to="'/album/show-'+item.basic_id+'.html'" title="item.title" v-else-if="item.type==1" target="_blank">
                                    <img class="foucs_img" :src="item.cover" :title="item.name">
                                </router-link>
                                <router-link :to="'/article/show-'+item.basic_id+'.html'" title="item.title" v-else target="_blank">
                                    <img class="foucs_img" :src="item.cover" :title="item.name">
                                </router-link>
                                <div class="foucs_text">
                                    <div class="tit">{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#newsfoucs" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#newsfoucs" data-bs-slide="next">
                            <span class="carousel-control-next-icon"></span>
                        </button>
                    </div>
                    <div class="index_topnews">
                        <div v-for="(item,index) in topping" :key="index" :data-bs-slide-to="index" class="thumb_img">
                            <a :href="item.link" v-if="item.type==4" target="_blank">
                                <div class="img"><img :src="item.cover"></div>
                                <div class="tit">{{item.title}}</div>
                            </a>
                            <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                                <div class="img"><img :src="item.cover"></div>
                                <div class="tit">{{item.title}}</div>
                            </router-link>
                            <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                                <div class="img">
                                    <img :src="item.cover">
                                    <div class="video_play"><i class="iconfont icon-shipin5" style="font-size:35px; color:#f1f1f1"></i></div>
                                </div>
                                <div class="tit">{{item.title}}</div>
                            </router-link>
                            <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                                <div class="img"><img :src="item.cover"></div>
                                <div class="tit">{{item.title}}</div>
                            </router-link>
                            <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                                <div class="img"><img :src="item.cover"></div>
                                <div class="tit">{{item.title}}</div>
                            </router-link>
                        </div>
                        <div style="clear:both"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-5 bt_left index_yaowenbox">
                    <div class="index_news index_yaowen">
                        <div class="index_news_tit" style="display:none">
                            <div class="news_type">要闻</div>
                            <div class="news_more">
                                <router-link to="/list_70.html" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_qiaojia">
                            <div class="news-a-no" v-for="(news,index) in qjnews" :key="index">
                                <a :href="item.link" v-if="news.type==4" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </a>
                                <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container margin-15 index_ads_box">
            <div class="row">
                <div class="col-xs-12 col-sm-4" style="padding-right:3px;">
                    <!-- 轮播 -->
                    <div id="'adsoneleft'+index" class="carousel slide" data-bs-ride="carousel">
                        <!-- 幻灯片/轮播 -->
                        <div class="carousel-inner index_ads">
                            <div v-for="(items,key) in adsoneleft" :key="key"  class="carousel-item" :class="key==0?'active':''">
                                <a :href="items.link?items.link:'#'" target="_blank">
                                <img :src="'https://www.ynqjnews.net'+items.image" :title="items.name" class="adsimgs">
                                </a>
                            </div>
                        </div>
                    </div>                
                </div>
                <div class="col-xs-12 col-sm-4 topmargin">
                    <!-- 轮播 -->
                    <div id="'adsoneleft'+index" class="carousel slide" data-bs-ride="carousel">
                        <!-- 幻灯片/轮播 -->
                        <div class="carousel-inner index_ads">
                            <div v-for="(items,key) in adsonecenter" :key="key"  class="carousel-item" :class="key==0?'active':''">
                                <a :href="items.link?items.link:'#'" target="_blank">
                                <img :src="'https://www.ynqjnews.net'+items.image" :title="items.name" class="adsimgs">
                                </a>
                            </div>
                        </div>
                    </div>                
                </div>
                <div class="col-xs-12 col-sm-4 topmargin" style="padding-left:3px;">
                    <!-- 轮播 -->
                    <div id="'adsoneleft'+index" class="carousel slide" data-bs-ride="carousel">
                        <!-- 幻灯片/轮播 -->
                        <div class="carousel-inner index_ads">
                            <div v-for="(items,key) in adsoneright" :key="key"  class="carousel-item" :class="key==0?'active':''">
                                <a :href="items.link?items.link:'#'" target="_blank">
                                <img :src="'https://www.ynqjnews.net'+items.image" :title="items.name" class="adsimgs">
                                </a>
                            </div>
                        </div>
                    </div>                
                </div>
            </div>
        </div>
        <div class="container margin-15">
            <div class="row">
                <div v-for="(item,index) in oneline" :key="index" class="col-xs-12 col-sm-4" :class="{'bt_right': index == 0 ,'bt_left': index == 2}">
                    <div class="index_news">
                        <div class="index_news_tit">
                            <div class="news_type">{{item.name}}</div>
                            <div class="news_more">
                                <router-link :to="'/list_'+item.id+'.html'" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_list">
                            <div class="index_news_photo" v-if="!isObjectEmpty(item.topimg)">
                                <div class="img">
                                    <a :href="item.topimg.link" v-if="item.topimg.type==4" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </a>
                                    <router-link :to="'/special/node_'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==3" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                    <router-link :to="'/video/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==2" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                    <router-link :to="'/album/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==1" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                    <router-link :to="'/article/show-'+item.topimg.basic_id+'.html'" v-else target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                </div>
                                <div class="tit">
                                    <a :href="item.topimg.link" v-if="item.topimg.type==4" target="_blank">
                                        {{item.topimg.title}}
                                    </a>
                                    <router-link :to="'/special/node_'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==3" target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                    <router-link :to="'/video/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==2" target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                    <router-link :to="'/album/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==1" target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                    <router-link :to="'/article/show-'+item.topimg.basic_id+'.html'" v-else target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                </div>
                            </div>
                            <div class="news-a-no" v-for="(news,index) in item.data" :key="index">
                                <a :href="item.link" v-if="news.type==4" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </a>
                                <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container margin-15 index_ads_box">
            <div id="adstwos" class="carousel slide" data-bs-ride="carousel">
                <!-- 幻灯片/轮播 -->
                <div class="carousel-inner index_ads">
                    <div v-for="(item,index) in adstwo" :key="index"  class="carousel-item" :class="index==0?'active':''">
                        <a :href="item.link?item.link:'#'" target="_blank">
                        <img :src="'https://www.ynqjnews.net'+item.image" :title="item.name" class="adsimgs">
                        </a>
                    </div>
                </div>
            </div>                
        </div>
        <div class="container margin-15">
            <div class="row">
                <div class="col-xs-12 col-sm-4 bt_right">
                    <div class="index_news">
                        <div class="index_news_tit">
                            <div class="news_type">通知公告</div>
                            <div class="news_more">
                                <router-link to="/list_79.html" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_list">
                            <div class="news-a-no" v-for="(news,index) in noticenews" :key="index">
                                <a :href="item.link" v-if="news.type==4" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </a>
                                <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="index_news">
                        <div class="index_news_tit">
                            <div class="news_tap" :class="{ 'tabactive': currentTab === 'tab0' }"  
        @mouseover="currentTab = 'tab0'">视听巧家</div>
                            <div class="news_tap" :class="{ 'tabactive': currentTab === 'tab1' }"  
        @mouseover="currentTab = 'tab1'">媒体关注</div>
                            <div class="news_more" v-if="currentTab === 'tab0'">
                                <router-link to="/list_80.html" target="_blank">更多</router-link>
                            </div>
                            <div class="news_more" v-if="currentTab === 'tab1'">
                                <router-link to="/list_81.html" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_list">
                            <div v-for="(item,index) in shitingmeiti" :key="index">
                                <div v-if="currentTab === 'tab'+index" class="tab_con">  
                                    <div class="news-a-no" v-for="(news,index) in item.data" :key="index">
                                        <a :href="item.link" v-if="news.type==4" target="_blank">
                                            <div class="tit">{{news.title}}</div>
                                        </a>
                                        <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 bt_left">
                    <div class="index_news">
                        <div class="index_news_tit">
                            <div class="news_type">国内新闻</div>
                            <div class="news_more">
                                <router-link to="/list_77.html" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_list">
                            <div class="news-a-no" v-for="(news,index) in guoneinews" :key="index">
                                <a :href="item.link" v-if="news.type==4" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </a>
                                <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
        <div class="container margin-15 index_ads_box">
            <div id="adsthree" class="carousel slide" data-bs-ride="carousel">
                <!-- 幻灯片/轮播 -->
                <div class="carousel-inner index_ads">
                    <div v-for="(item,index) in adsthree" :key="index"  class="carousel-item" :class="index==0?'active':''">
                        <a :href="item.link?item.link:'#'" target="_blank">
                        <img :src="'https://www.ynqjnews.net'+item.image" :title="item.name" class="adsimgs">
                        </a>
                    </div>
                </div>
            </div>                
        </div>
        <div class="container margin-15">
            <div class="row">
                <div v-for="(item,index) in threeline" :key="index" class="col-xs-12 col-sm-4" :class="{'bt_right': index == 0 ,'bt_left': index == 2}">
                    <div class="index_news">
                        <div class="index_news_tit">
                            <div class="news_type">{{item.name}}</div>
                            <div class="news_more">
                                <router-link :to="'/list_'+item.id+'.html'" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_list">
                            <div class="news-a-no" v-for="(news,index) in item.data" :key="index">
                                <a :href="item.link" v-if="news.type==4" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </a>
                                <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 bt_left">
                    <div class="index_news">
                        <div class="index_news_tit">
                            <div class="news_type">健康巧家</div>
                            <div class="news_more">
                                <router-link to="/zhuanti/node_368223.html" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_list">
                            <div class="news-a-no" v-for="(news,index) in jkqjnews" :key="index">
                                <a :href="item.link" v-if="news.type==4" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </a>
                                <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container margin-15">
            <div class="index_news">
                <div class="index_news_tit">
                    <div class="news_type">图说巧家</div>
                    <div class="news_more">
                        <router-link to="/list_82.html" target="_blank">更多</router-link>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="index_photo">
                    <swiper
                        :modules="modules"
                        :slides-per-view="photorows"
                        :space-between="20"
                        autoplay
                        navigation
                        @swiper="onSwiper"
                        @slideChange="onSlideChange"
                    >
                    <swiper-slide v-for="(item,index) in photos" :key="index">
                        <div class="index_photo_item">
                            <a :href="item.link" v-if="item.type==4" target="_blank">
                                <img :src="item.cover">
                            </a>
                            <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                                <img :src="item.cover">
                            </router-link>
                            <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                                <img :src="item.cover">
                            </router-link>
                            <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                                <img :src="item.cover">
                            </router-link>
                            <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                                <img :src="item.cover">
                            </router-link>
                            <p>{{item.title}}</p>
                        </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>

        <div class="container margin-15 index_ads_box">
            <div id="adsfors" class="carousel slide" data-bs-ride="carousel">
                <!-- 幻灯片/轮播 -->
                <div class="carousel-inner index_ads">
                    <div v-for="(item,index) in adsfor" :key="index"  class="carousel-item" :class="index==0?'active':''">
                        <a :href="item.link?item.link:'#'" target="_blank">
                        <img :src="'https://www.ynqjnews.net'+item.image" :title="item.name" class="adsimgs">
                        </a>
                    </div>
                </div>
            </div>                
        </div>
        <div class="container margin-15">
            <div class="row">
                <div v-for="(item,index) in forline" :key="index" class="col-xs-12 col-sm-4" :class="{'bt_right': index == 0 ,'bt_left': index == 2}">
                    <div class="index_news">
                        <div class="index_news_tit">
                            <div class="news_type">{{item.name}}</div>
                            <div class="news_more">
                                <router-link :to="'/list_'+item.id+'.html'" target="_blank">更多</router-link>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="index_news_list">
                            <div class="index_news_photo" v-if="!isObjectEmpty(item.topimg)">
                                <div class="img">
                                    <a :href="item.topimg.link" v-if="item.topimg.type==4" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </a>
                                    <router-link :to="'/special/node_'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==3" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                    <router-link :to="'/video/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==2" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                    <router-link :to="'/album/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==1" target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                    <router-link :to="'/article/show-'+item.topimg.basic_id+'.html'" v-else target="_blank">
                                        <img :src="item.topimg.cover" :title="item.topimg.title">
                                    </router-link>
                                </div>
                                <div class="tit">
                                    <a :href="item.topimg.link" v-if="item.topimg.type==4" target="_blank">
                                        {{item.topimg.title}}
                                    </a>
                                    <router-link :to="'/special/node_'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==3" target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                    <router-link :to="'/video/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==2" target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                    <router-link :to="'/album/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==1" target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                    <router-link :to="'/article/show-'+item.topimg.basic_id+'.html'" v-else target="_blank">
                                        {{item.topimg.title}}
                                    </router-link>
                                </div>
                            </div>
                            <div class="news-a-no" v-for="(news,index) in item.data" :key="index">
                                <a :href="item.link" v-if="news.type==4" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </a>
                                <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                                <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                    
                                    <div class="tit">{{news.title}}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="rongmeiti">
                <div class="rongmei_type">
                    融<br>媒<br>矩<br>阵
                </div>
                <div class="rongmei_qrcode">
                    <div v-for="(item,index) in qrcodes" :key="index" class="qr_img">
                        <img :src="'https://images.ztnews.net'+item.image">
                        <p>{{item.name}}</p>
                    </div>
                </div>
            </div>
            <div style="clear:both"></div>
        </div>
        <div class="container margin-15">
            <div class="index_news">
                <div class="index_news_tit">
                    <div class="news_type">公益广告</div>
                    <div class="news_more" style="display:none">
                        <a href="#">更多</a>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="index_gongyi">
                    <swiper
                        :modules="modules"
                        :slides-per-view="gongyirows"
                        :space-between="20"
                        navigation
                        autoplay
                        @swiper="onSwiper"
                        @slideChange="onSlideChange"
                    >
                        <swiper-slide v-for="(item,index) in gongyi" :key="index">
                            <div class="gongyi_img">
                                <a :href="item.link?item.link:'#'" target="_blank">
                                    <img :src="'https://www.ynqjnews.net'+item.image" :title="item.name">
                                </a>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>

        <div class="container margin-15">
            <div class="index_news">
                <div class="index_news_tit">
                    <div class="news_type">便民服务</div>
                    <div class="news_more" style="display:none">
                        <a href="#">更多<i class="iconfont icon-xiayiyeqianjinchakangengduo-yuankuang"></i>
                        </a>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="index_serve">
                    <div class="serve_box" v-for="(item,index) in bianmin" :key="index">
                        <a :href="item.url" target="_blank">
                            <img :src="'https://www.ynqjnews.net'+item.logo.replace(/\/120/g, '')">
                            <p>{{item.name}}</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { post } from '../../request'
    import { Swiper, SwiperSlide } from 'swiper/vue'
    import { Navigation, Scrollbar, A11y, Autoplay } from 'swiper/modules'
    import 'swiper/css'
    import 'swiper/css/navigation'
    import 'swiper/css/scrollbar'
    import TopAds from '@/components/TopAds.vue'
    import HeaderPage from '@/components/HeaderUnit.vue'
    export default {
        components: {
            TopAds,
            HeaderPage,
            Swiper,
            SwiperSlide,
        },
        setup() {
            const onSwiper = () => {
                //console.log(swiper);
            };
            const onSlideChange = () => {
                //console.log('slide change');
            };
            return {
                onSwiper,
                onSlideChange,
                modules: [Navigation, Scrollbar, A11y, Autoplay],
            };
        },
        data() {
            return {
                specialrows: 4,
                photorows:5,
                gongyirows: 6,
                title: '巧家新闻网—巧家县第一新闻门户网站',
                keywords: ['巧家新闻','巧家','白鹤滩','巧家县','巧家新闻网'],
                description: '巧家县第一新闻门户网站，巧家新闻网由中共巧家县委宣传部主办、巧家县人民政府新闻中心承办，是对外宣传推介巧家、展示巧家形象、外界了解巧家的重要网络平台。',
                specials:[],
                guoneitop: [],
                topspecial: [],
                bdnewstop: [],
                foucsnews:[],
                qjnews: [],
                topping: [],
                currentTab: 'tab0',
                oneline: [
                    { id: 90, name: '领导活动', data: [], topimg: {} },  
                    { id: 72, name: '乡镇', data: [], topimg: {} },  
                    { id: 87, name: '社会民生', data: [], topimg: {} },  
                ],
                noticenews:[],  
                shitingmeiti: [
                    { id: 80, name: '视听巧家', data: [], topimg: {} },  
                    { id: 81, name: '媒体关注', data: [], topimg: {} },  
                ],  
                guoneinews:[],
                threeline: [
                    { id: 92, name: '政策解读', data: [], topimg: {} },  
                    { id: 91, name: '理论调研', data: [], topimg: {} },  
                    //{ id: 85, name: '健康巧家', data: [], topimg: {} },  
                ],  
                forline: [
                    { id: 78, name: '文化旅游', data: [], topimg: {} },  
                    { id: 88, name: '平安巧家', data: [], topimg: {} },  
                    { id: 86, name: '文明巧家', data: [], topimg: {} },  
                ],  
                adsoneleft:[],
                adsonecenter:[],
                adsoneright:[],
                adstwo:[],
                adsthree: [],
                adsfor: [],
                bianmin: [],
                photos:[],
                qrcodes:[],
                gongyi:[],
                jkqjnews:[]
            }
        },
        created() {
            this.getSpicial()
            this.getGuoneitop()
            this.getTopspecial()
            this.getBdnewstop()
            this.getTopping()
            this.getFoucsnews()
            this.getQjnews()
            this.getOneline()
            this.getNotice()
            this.getMeiti()
            this.getGuonei()
            this.getThreeline()
            this.getForline()
            this.getAdsoneleft()
            this.getAdsonecenter()
            this.getAdsoneright()
            this.getAdstwo()
            this.getAdsthree()
            this.getAdsfor()
            this.getBianmin()
            this.getPhotos()
            this.getQrcode()
            this.getGongyi()
            this.getJkqj()
        },
        mounted() {
            this.setTitle();  
            this.setKeywords();  
            this.setDescription();  
            this.checkWidth();  
            window.addEventListener('resize', this.checkWidth);  
        },
        beforeDestroy() {  
            window.removeEventListener('resize', this.checkWidth);  
        }, 
        methods: {
            resetTab() {  
                this.currentTab = 'tab1'; 
            },  
            checkWidth() {  
                if(window.innerWidth <= 767){
                    this.specialrows = 2
                    this.photorows = 2
                    this.gongyirows = 3
                }else{
                    this.specialrows = 4
                    this.photorows = 4
                    this.gongyirows = 6
                }
                //console.log(this.isLessThan767 ? 'Width is less than 767px' : 'Width is greater than or equal to 767px');  
            }, 
            isObjectEmpty(obj) {  
                return JSON.stringify(obj) === '{}';  
            },  
            setTitle() {  
                document.title = this.title; // 设置标题  
            },  
            setKeywords() {  
                const metaKeywords = document.createElement('meta');  
                metaKeywords.name = 'keywords';  
                metaKeywords.content = this.keywords.join(','); // 设置关键词  
                document.head.appendChild(metaKeywords);  
            },  
            setDescription() {  
                const metaDescription = document.createElement('meta');  
                metaDescription.name = 'description';  
                metaDescription.content = this.description; // 设置描述  
                document.head.appendChild(metaDescription);  
            },
            async getNotice() {  
                let that = this
                try {  
                    const postData = {'page': 1,'length': 5};  
                    const response = await post('column/79', postData);  
                    //console.log(response)
                    that.noticenews = response.data
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getGuonei() {  
                let that = this
                try {  
                    const postData = {'page': 1,'length': 5};  
                    const response = await post('column/77', postData);  
                    //console.log(response)
                    that.guoneinews = response.data
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getGuoneitop() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/news/1', postData);  
                    //console.log(response)
                    that.guoneitop = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getTopping() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/news/3', postData);  
                    //console.log(response)
                    that.topping = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getTopspecial() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/10', postData);  
                    that.topspecial = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getBdnewstop() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/news/2', postData);  
                    //console.log(response)
                    that.bdnewstop = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getFoucsnews() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/news/4', postData);  
                    //console.log(response)
                    that.foucsnews = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getQjnews() {  
                let that = this
                try {  
                    const postData = {'page': 1,'length': 12};  
                    const response = await post('column/70', postData);  
                    //console.log(response)
                    that.qjnews = response.data
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  

            async getOneline() {  
                try {  
                    for (const onelines of this.oneline) { 
                        const postData = {'page': 1,'length': 5};
                        const response = await post(`column/${onelines.id}`, postData);  
                        if (response.data) {  
                            onelines.data = response.data;
                            const topNews = response.data.find(news => news.cover);   
                            if (topNews) {  
                                onelines.topimg = topNews;  
                            } else {  
                                onelines.topimg = {}; 
                            }                         
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },  
            async getMeiti() {  
                try {  
                    for (const towlines of this.shitingmeiti) { 
                        const postData = {'page': 1,'length': 5};
                        const response = await post(`column/${towlines.id}`, postData);  
                        if (response.data) {  
                            towlines.data = response.data;
                            const topNews = response.data.find(news => news.cover);   
                            if (topNews) {  
                                towlines.topimg = topNews;  
                            } else {  
                                towlines.topimg = {}; 
                            }                         
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },  
            async getThreeline() {  
                try {  
                    for (const threelines of this.threeline) { 
                        const postData = {'page': 1,'length': 5};
                        const response = await post(`column/${threelines.id}`, postData);  
                        if (response.data) {  
                            threelines.data = response.data;
                            const topNews = response.data.find(news => news.cover);   
                            if (topNews) {  
                                threelines.topimg = topNews;  
                            } else {  
                                threelines.topimg = {}; 
                            }                         
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },  
            async getForline() {  
                try {  
                    for (const forlines of this.forline) { 
                        const postData = {'page': 1,'length': 5};
                        const response = await post(`column/${forlines.id}`, postData);  
                        if (response.data) {  
                            //console.log(response.data)
                            forlines.data = response.data;
                            const topNews = response.data.find(news => news.cover);   
                            if (topNews) {  
                                forlines.topimg = topNews;  
                            } else {  
                                forlines.topimg = {}; 
                            }                         
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },  
            async getAdsoneleft() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/1', postData);  
                    //console.log(response)
                    that.adsoneleft = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getAdsonecenter() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/2', postData);  
                    //console.log(response)
                    that.adsonecenter = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getAdsoneright() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/3', postData);  
                    //console.log(response)
                    that.adsoneright = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
 
            async getAdstwo() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/4', postData);  
                    //console.log(response)
                    that.adstwo = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getAdsthree() {  
                let that = this
                try {  
                    const postData = {'page': 1,'length': 17};  
                    const response = await post('page/banner/5', postData);  
                    that.adsthree = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getAdsfor() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/6', postData);  
                    //console.log(response)
                    that.adsfor = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getBianmin() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/links/10', postData);  
                    //console.log(response)
                    that.bianmin = response.data
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getPhotos() {  
                let that = this
                try {  
                    const postData = {'page': 1,'length': 8};  
                    const response = await post('column/82', postData);  
                    //console.log(response)
                    that.photos = response.data
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getQrcode() {  
                let that = this
                try {  
                    const postData = {'limit': 6};  
                    const response = await post('page/banner/13', postData);  
                    //console.log(response)
                    that.qrcodes = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getJkqj() {  
                let that = this
                try {  
                    const postData = {'page': 1,'length': 5 };  
                    const response = await post('specialNews/368223', postData);  
                    //console.log(response.data)
                    that.jkqjnews = response.data
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getGongyi() {  
                let that = this
                try {  
                    const postData = {'limit': 24};  
                    const response = await post('page/banner/12', postData);  
                    //console.log(response)
                    that.gongyi = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getSpicial() {  
                let that = this
                try {  
                    const postData = {'limit': 24};  
                    const response = await post('page/banner/10', postData);  
                    //console.log(response)
                    that.specials = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  

        },
    }
</script>
<style scoped>
body{
   background: #f6f7f8!important;
}
.adsimgs{ height: 90px; width: 100%;}
.index_bigfoucs{ width:830px; padding-left:0px;}
.index_yaowenbox{ width:524px; padding-right:0px;}
.index_yaowen{ width:100%;}


.news_tap{  
    cursor: pointer; /* 显示为可点击 */  
    margin-left: 10px;
    text-align: center;
    width: auto;
    height: 50px;
    color: #3494f0;
    font-size: 20px;
    float: left;
    font-weight: bold;
}

.tabactive {  
    border-bottom: 3px solid #3494f0;
}  
  
.fade-enter-active, .fade-leave-active {  
  transition: opacity 0.5s;  
}  
  
.fade-enter, .fade-leave-to {  
  opacity: 0;  
}  
@media(max-width:767px){
    .index_bigfoucs{ width:100%; padding-left:0px;}
    .index_yaowenbox{ width:100%; padding-right:10px;}
    .adsimgs{ height: auto; width: 100%;}
    .topmargin{ margin-top:5px; padding: 0px;}
}
</style>
    